import { CheckOutlined } from '@ant-design/icons'
import { Button, Popconfirm } from 'antd'
import { FC } from 'react'
import { useAcceptReceiptPositionMutation } from '../../../../../../../store/api/receipt-positions-api'
import useErrorModal from '../../../../../../../hooks/api/use-error-modal'
import useSuccessModal from '../../../../../../../hooks/api/use-success-modal'

interface AcceptProps {
    documentId: string
}

const Accept: FC<AcceptProps> = ({ documentId }) => {
    const [accept, acceptState] = useAcceptReceiptPositionMutation()

    useErrorModal(acceptState, 'Ошибка приёмки позиции')
    useSuccessModal(acceptState, 'Позиция принята')

    return (
        <Popconfirm
            title={'Принять позицию?'}
            description={'Остаток материала будет пополнен'}
            okText={'Принять'}
            cancelText={'Отмена'}
            onConfirm={() => accept(documentId)}
        >
            <Button
                size={'small'}
                icon={<CheckOutlined />}
                color='green'
                variant={'outlined'}
                title={'Принять позицию'}
                loading={acceptState.isLoading}
            />
        </Popconfirm>
    )
}

export default Accept
